import React, { Component } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

class RichTextEditor  extends Component {
	
	render() {
		let editorConfig = {placeholder: this.props.placeholder || "Type here"};
		if(this.props.hideToolbar) editorConfig.toolbar = false;
        return (
            <div className="App">
                <CKEditor
                    editor={ ClassicEditor }
                    data={this.props.value}
                    onInit={ editor => {
						this.props.height !== false && editor.editing.view.change((writer) => {
							writer.setStyle(
								"height",
								this.props.height || "120px",
								editor.editing.view.document.getRoot()
							);
						});
					} }
					
					config={{...editorConfig }}
                    onChange={ ( event, editor ) => this.props.onChange(editor.getData())}
                    onBlur={ ( event, editor ) => {} }
                    onFocus={ ( event, editor ) => {
                        console.log( 'Focus.', editor );
                    } }
                />
            </div>
        );
    }

}

export default RichTextEditor ;